// extracted by mini-css-extract-plugin
module.exports = {"root":"Blog_root__RfhAP","head":"Blog_head__bPA0z","linkBack":"Blog_linkBack__gq7jK","blogDate":"Blog_blogDate__ZDj15","image":"Blog_image__qvtj6","content":"Blog_content__1PyT6"};